import { render, staticRenderFns } from "./FooterSm.vue?vue&type=template&id=0def5c71&scoped=true&"
import script from "./FooterSm.vue?vue&type=script&lang=js&"
export * from "./FooterSm.vue?vue&type=script&lang=js&"
import style0 from "./FooterSm.vue?vue&type=style&index=0&id=0def5c71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def5c71",
  null
  
)

export default component.exports